<template>
  <div v-if="shouldRenderConfig" :class="getClassName">
    {{ getWebProductName }}
  </div>
</template>
<script>
import { useWebproductStore } from "@/stores/modules/webproduct";
import { mapState, mapActions } from "pinia";

export default {
  computed: { ...mapState(useWebproductStore, ["getWebProductName"]) }
};
</script>
